export default __webpack_public_path__ + "static/media/about-thumb-6-challenge.e82295a3.jpg";